import { useSession } from "@/contexts/session";
import { useRouter } from "next/router";

import Image from "next/image";
import FidelidadeIcon from 'public/icons/fidelidade40x.svg';
import UserIcon from 'public/icons/user18x_green.svg';

import money from "@/helpers/money";
import styles from "./CashbackAlert.module.css";
import Link from "next/link";
import useMediaQuery from "@/hooks/useMediaQuery";
import { useAccumulation } from "@/hooks/useAccumulation";
import { useSettings } from "@/contexts/settings";

interface CashbackAlertProps {
  isApplied?: boolean;
  value?: number;
  isMobile?: boolean;
  isLoginPage?: boolean;
  forceGenericMessage?: boolean;
  fullWidth?: boolean;
}

export default function CashbackAlert({ isApplied, value, isMobile, isLoginPage, forceGenericMessage, fullWidth }: CashbackAlertProps) {
  const router = useRouter();
  const { customer } = useSession();
  const match = useMediaQuery(1024);
  const matchTablet = useMediaQuery(768);
  const { cashbackPercentage } = useSettings();
  const { data: accumulation } = useAccumulation();

  if (isMobile && match) {
    return null;
  }

  if (isApplied) {
    return (
      <div className={`${styles.applied_card} ${fullWidth ? styles.full_width : ''}`}>
        <div className={styles.applied_container}>
          <FidelidadeIcon width="18" height="18" />
          <p className={styles.applied_text}>Cashback {value && `de ${money(value)}`} aplicado com sucesso!</p>
        </div>
      </div>
    )
  }

  if (customer && !isLoginPage) {
    if (!forceGenericMessage && accumulation?.cashbackValue && accumulation.cashbackValue > 0) {
      return (
        <div className={`${styles.alert_container} ${styles.alert_container_mobile}`}>
          <div className={styles.alert_content}>
            <FidelidadeIcon width="20" height="20" />
            <p className={styles.alert_text}>Valor acumulado nesta reserva: <strong>{money(accumulation.cashbackValue)}</strong></p>
          </div>
        </div>
      )
    }

    return (
      <div className={`${styles.alert_container} ${styles.alert_container_mobile}`}>
        <div className={styles.alert_content}>
          <Image src={"/icons/fidelidade20x.svg"} alt="" width={20} height={20} />
          <p className={styles.alert_text}>Conclua sua reserva e acumule até {cashbackPercentage ?? 15}% de cashback.</p>
        </div>
      </div>
    )
  }

  return (
    <div className={`${styles.applied_card} ${fullWidth ? styles.full_width : ''}`}>
      <div className={styles.applied_container}>
        <UserIcon />
        <p className={styles.applied_text}>
          {!isLoginPage ? <Link href={`/login?${new URLSearchParams(router.query as Record<string, string>).toString()}&ref=${router.pathname}`}>
            Faça login
          </Link> : "Faça login"}
          {" "}
          e acumule até{isLoginPage && !matchTablet ? <br className={styles.msg_line} /> : " "}{cashbackPercentage ?? 15}% de cashback
        </p>
      </div>
    </div>
  )
}
